import { render, staticRenderFns } from "./LeaveRecentUpdates.vue?vue&type=template&id=088dd7ad"
import script from "./LeaveRecentUpdates.vue?vue&type=script&lang=js"
export * from "./LeaveRecentUpdates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports